import { Controller } from "stimulus"

// TODO: Update aria-expanded correctly.
export default class extends Controller {
  static get targets() {
    return [
      // Content within the dropdown menu.
      "dropdown"
    ]
  }

  /**
   * disconnect closes any open dropdowns on DOM exit by adding the `hidden`
   * class and removing the close event listener from the body.
   */
  disconnect = () => {
    if (!this.dropdownTarget.classList.contains("hidden")) {
      this.dropdownTarget.classList.add("hidden")
      document.querySelector("body").removeEventListener("click", this._handleCloseClicks)
    }
  }

  toggle = (ev) => {
    if (this.dropdownTarget.classList.contains("hidden")) {
      this.dropdownTarget.classList.remove("hidden")
      ev.stopPropagation()
      document.querySelector("body").addEventListener("click", this._handleCloseClicks)
    }
  }

  _handleCloseClicks = (ev) => {
    if (!this.dropdownTarget.contains(ev.target)) {
      this.dropdownTarget.classList.add("hidden")
      document.querySelector("body").removeEventListener("click", this._handleCloseClicks)
    }
  }
}
